import React from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

const TitleComponent = props => {
  const path = props.history.location.pathname.toLowerCase()
  let defaultTitle = 'Berkadia 360';
  switch (path) {
    case '/propertysearch':
      defaultTitle = 'Property Search';
      break
    case '/propertylists':
      defaultTitle = 'Property Lists';
      break
    case '/emaillists':
      defaultTitle = 'Email Lists - Search';
      break
    case '/emaillistinitialpage':
      defaultTitle = 'Email Lists - Dashboard';
      break
    case '/emaillistdetails':
      defaultTitle = 'Email List - Details';
      break
    default:
      break
  }
  // const defaultTitle =
  //   path === '/propertysearch'
  //     ? 'Property Search'
  //     : path === '/emaillists' || path === '/emaillistinitialpage'
  //     ? 'Email Lists'
  //     : 'Berkadia 360'

  return (
    <Helmet>
      <title>{defaultTitle}</title>
    </Helmet>
  )
}

TitleComponent.propTypes = {
  history: PropTypes.object
}

export default withRouter(TitleComponent)
